import { render } from "./DesktopBar.vue?vue&type=template&id=378386fb&scoped=true&ts=true"
import script from "./DesktopBar.vue?vue&type=script&lang=ts"
export * from "./DesktopBar.vue?vue&type=script&lang=ts"

import "./DesktopBar.vue?vue&type=style&index=0&id=378386fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378386fb"]])

export default __exports__